import { render, staticRenderFns } from "./CustomFieldCheckbox.vue?vue&type=template&id=2272e5e6&scoped=true"
import script from "./CustomFieldCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldCheckbox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomFieldCheckbox.vue?vue&type=style&index=0&id=2272e5e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272e5e6",
  null
  
)

export default component.exports